import api from '@shop/frontend/web/js/api';

const hasIncompleteOrders = async () => {
  const response = await api.cart.checkExpectedOrders();
  return response.isExpectedOrders;
};

const showPopupIfIncompleteOrder = async () => {
  const popup = document.querySelector('.incompleate-order-popup');
  const closeButton = popup.querySelector('.incompleate-order-popup__close-button');

  closeButton.addEventListener('click', (e) => {
    e.preventDefault();
    popup.classList.add('d-none');
  });

  if (await hasIncompleteOrders()) {
    popup.classList.add('d-block');
  }
};

showPopupIfIncompleteOrder();
